var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenupicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 22.2385L25.5917 29.2916L27.75 27.1333L18.5 17.8833L9.25 27.1333L11.4083 29.2916L18.5 22.2385ZM18.5 12.0635L25.5917 19.1166L27.75 16.9583L18.5 7.70829L9.25 16.9583L11.4083 19.1166L18.5 12.0635Z",
    fill: "#00711A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenupicon);
export default __webpack_public_path__ + "static/media/greenupicon.1f1bdc4e94b3984de4d31fb6282fc301.svg";
export { ForwardRef as ReactComponent };